<template>
	<div id="app_benifits" name="app_benifits" class="app-benifits">
		<h3 class="bf-title">{{ appBenifit.title }}</h3>
		<p class="bf-subtitle">{{ appBenifit.subTitle }}</p>
		<div class="bf-detail">
			<ul class="bf-detail-list dp-f">
				<li
					class="block"
					v-for="item in appBenifit.list"
					:style="`background-image: url('${item.icon}')`"
					:key="item.title"
				>
					<div class="title icon-search">{{ item.title }}</div>
					<div class="compare">{{ item.before }}</div>
					<div class="compare">{{ item.after || '' }}</div>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		appBenifit: {
			type: Object,
			required: true,
		},
	},
}
</script>
<style lang="scss" scoped>
.app-benifits {
	padding-top: 100px;
	.bf-title {
		font-size: 32px;
		color: #3f4657;
		text-align: center;
	}
	.bf-subtitle {
		margin-top: 24px;
		font-size: 16px;
		text-align: center;
		color: #6d6d6d;
	}
	.bf-detail-list {
		justify-content: center;
		flex-wrap: wrap;
		max-width: 1200px;
		margin: 0 auto;
		.block {
			width: 400px;
			margin: 64px 60px 0;
			background-size: 40px 40px;
			background-position: 0 0;
			background-repeat: no-repeat;
		}
		.title {
			color: #3f4657;
			line-height: 40px;
			font-size: 18px;
			text-indent: 56px;
		}
		.compare {
			line-height: 20px;
			font-size: 14px;
			margin-top: 16px;
			color: #575757;
		}
	}
}

@media (max-width: 414px) {
	.app-benifits {
		padding-top: 80px;
		.bf-detail-list {
			.block {
				margin: 40px 16px 0;
			}
		}
	}
}
</style>
